import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import { Observable } from "rxjs";

import {
  BranchList,
  CIReportDownloadPayload,
  CIReportFilterOptions,
  CIReportFilterOptionsPayload,
  FilteredAgentQuery,
  SearchReport,
} from "./ci-report.interface";

interface CIReportServiceResponse<T> {
  data?: T;
}

interface BranchListResponseData {
  userBranchList: BranchList[];
}

interface AgentListResponseData {
  agentList: BranchList[];
}

@Injectable()
export class CIReportService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getBranchList(
    userId: string,
  ): Observable<CIReportServiceResponse<BranchListResponseData>> {
    return this.httpHelperService.get(
      `/common/lov/type?userId=${userId}&listType=userBranchList`,
    );
  }

  public getAgentList(
    userId: string,
  ): Observable<CIReportServiceResponse<AgentListResponseData>> {
    return this.httpHelperService.get(`/common/agents?userId=${userId}`);
  }

  public getFilteredAgentList(
    body: FilteredAgentQuery,
  ): Observable<CIReportServiceResponse<AgentListResponseData>> {
    return this.httpHelperService.post(`/common/agents`, body);
  }

  public reportSearch(
    body: CIReportDownloadPayload,
  ): Observable<CIReportServiceResponse<SearchReport>> {
    return this.httpHelperService.post(`/report/production/search`, body);
  }

  public downloadReport(body: CIReportDownloadPayload): Window | null {
    const params = this.buildDownloadReportParams(body);

    return window.open(
      this.httpHelperService.getURLString(
        `/report/production/download?${params}`,
      ),
    );
    // return this.httpHelperService.getURL(`/report/production/download?${params}`);
  }

  public getReportTypeFilterOptions(
    body: CIReportFilterOptionsPayload,
  ): Observable<CIReportServiceResponse<CIReportFilterOptions>> {
    const { userId, productType, reportType, productCode } = body;
    let url = "/common/lov/report?";
    if (userId) {
      url = url + "userId=" + userId;
    }
    if (productType) {
      url = url + "&productType=" + productType;
    }
    if (reportType) {
      url = url + "&reportType=" + reportType;
    }
    if (productCode) {
      url = url + "&productCode=" + productCode;
    }
    return this.httpHelperService.get(url);
  }

  private buildDownloadReportParams(body: CIReportDownloadPayload): HttpParams {
    const {
      branchCode,
      agentCode,
      startDate,
      endDate,
      operator,
      mainProductType,
      type,
      productType,
      reportType,
      nonConvertedType,
      ubbCriteria,
      productCode,
      allProductIncInd,
      cumulativeDate,
      address,
      clientPostcode,
      clientCity,
      clientState,
      clientCountry,
      riskAccuPeril,
      riskAccuStatus,
      ciBatchId,
      searchByValue,
      searchByCriteria,
      renewalAsstInd,
    } = body;

    return new HttpParams()
      .set("userId", operator)
      .set("branchCode", branchCode)
      .set("agentCode", agentCode)
      .set("startDate", startDate)
      .set("endDate", endDate)
      .set("mainProductType", mainProductType)
      .set("productType", productType)
      .set("reportType", reportType)
      .set("nonConvertedType", nonConvertedType)
      .set("ubbCriteria", ubbCriteria)
      .set("productCode", productCode)
      .set("allProductIncInd", allProductIncInd)
      .set("cumulativeDate", cumulativeDate)
      .set("address", address)
      .set("clientPostcode", clientPostcode)
      .set("clientCity", clientCity)
      .set("clientState", clientState)
      .set("clientCountry", clientCountry)
      .set("riskAccuPeril", riskAccuPeril)
      .set("riskAccuStatus", riskAccuStatus)
      .set("type", type)
      .set("ciBatchId", ciBatchId)
      .set("searchByValue", searchByValue)
      .set("searchByCriteria", searchByCriteria)
      .set("renewalAsstInd", renewalAsstInd);
  }
}
